import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cd3d026"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "propose-app" }
const _hoisted_2 = { class: "propose-app-inner" }
const _hoisted_3 = { class: "propose-app-inner-data" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "Our app has everything you will need to track your progress and reach your goals.", -1))
const _hoisted_6 = { class: "btn-box" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "qr-code-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"stores\" data-v-5cd3d026><a class=\"play-store\" target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.clubhouse.clubhouse_client\" data-v-5cd3d026><div class=\"play-store-icon\" data-v-5cd3d026></div><div class=\"store-data\" data-v-5cd3d026><p class=\"store-data-desc\" data-v-5cd3d026>Get it on</p><h6 class=\"store-data-name\" data-v-5cd3d026>Play Store</h6></div></a><a class=\"play-store\" target=\"_blank\" href=\"https://apps.apple.com/us/app/erf-clubhouse/id6526485959\" data-v-5cd3d026><div class=\"app-store-icon\" data-v-5cd3d026></div><div class=\"store-data\" data-v-5cd3d026><div class=\"store-data-desc\" data-v-5cd3d026>Download on the</div><div class=\"store-data-name\" data-v-5cd3d026>App Store</div></div></a></div>", 1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Stay in browser")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($props.title), 1),
        ($setup.isAndroidDevice || $setup.isIOSdevice || $setup.isMobile)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  class: "button default primary w-full",
                  href: $setup.destinationLink,
                  target: "_blank"
                }, "Open the app", 8, _hoisted_7)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString($props.desc) + " ", 1),
                _hoisted_9,
                _createElementVNode("b", null, _toDisplayString($props.boldDesc), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  class: "qr-code",
                  src: require('@/assets/img/qr-code' + `${['dev', 'staging'].includes($setup.currentEnv) ? '-dev' : ''}` + '.png'),
                  alt: "QR-code"
                }, null, 8, _hoisted_11)
              ]),
              _hoisted_12,
              ($props.showStayInBrowser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "button default join",
                    to: { name: 'Onboarding' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ])
  ]))
}